import { FC, ReactNode } from 'react';
import Header from '../Header/Header';
import Protect from '../Protect/Protect';
import Sidemenu from '../Sidemenu/Sidemenu';
import LayoutProvider from './LayoutProvider';

interface LayoutProps {
    children: ReactNode
    action?: string
    subject?: string
}

const Layout: FC<LayoutProps> = props => {

    const { children, action, subject } = props

    return (
        <Protect action={action} subject={subject}>
            <LayoutProvider>
                <Header />
                <Sidemenu />
                {children}
            </LayoutProvider>
        </Protect>
    )
}

export default Layout;
